import type { PersonProfile } from '@openeducation/oe-rn-shared-types';
import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class InternalStudentLevelsDao {
  static async changeStudentLevel(
    env: Environment,
    personId: number,
    contactId: string,
    levelNum: string
  ) {
    const url = hostsConfig[env].internalProfileServiceUrl;
    const { data } = await axios.put<PersonProfile>(
      `${url}/internal/persons/levels`,
      { personId, contactId, levelNum }
    );
    return data;
  }
}
